import React, { useEffect } from 'react';
import { dateRangeValidate, getErrorHelperText } from 'consts';
import {
  Controller,
  DeepRequired,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  Path,
  UseFormReturn,
} from 'react-hook-form';
import DatePicker, { DatePickerProps } from 'components/DatePicker/DatePicker';

interface DateTimeStartEndProps<T extends FieldValues>
  // name value為必填 先移除
  extends Omit<DatePickerProps, 'name' | 'value'> {
  // 兩個日期之間不可超過的天數 預設30天
  rangeDay?: number;
  required?: boolean;
  formReturn: UseFormReturn<T>;
  startDateName: Path<T>;
  endDateName: Path<T>;
  startDateError:
    | Merge<FieldError, FieldErrorsImpl<DeepRequired<Date>>>
    | FieldError
    | undefined;
  endDateError:
    | Merge<FieldError, FieldErrorsImpl<DeepRequired<Date>>>
    | FieldError
    | undefined;
  errorString?: string;
  isDisabled?: boolean;
}

const DateTimeStartEnd = <T extends FieldValues>(
  props: DateTimeStartEndProps<T>,
): JSX.Element => {
  const {
    errorString,
    formReturn,
    startDateName,
    endDateName,
    startDateError,
    endDateError,
    required,
    rangeDay = 999999999999,
    isDisabled,
    ...other
  } = props;

  const { watch, control, getValues, trigger } = formReturn;

  watch(startDateName);
  watch(endDateName);

  const startDate = getValues(startDateName);
  const endDate = getValues(endDateName);

  const startEndError =
    (startDate || endDate) && !(startDate && endDate)
      ? '請輸入完整的起、迄日期。'
      : undefined;

  useEffect(() => {
    trigger(startDateName);
    trigger(endDateName);
  }, [startDate, endDate]);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Controller
        name={startDateName}
        control={control}
        rules={{
          validate: () =>
            errorString ||
            startEndError ||
            dateRangeValidate(startDate as Date, endDate as Date, rangeDay),
        }}
        render={({ field }) => {
          return (
            <DatePicker
              {...other}
              {...field}
              {...getErrorHelperText(startDateError)}
              required={required}
              value={field.value}
              disabled={isDisabled}
              isDisabled={isDisabled}
              onChange={({ value }) => {
                trigger(endDateName);
                field.onChange(value);
              }}
            />
          );
        }}
      />

      <span>～</span>

      <Controller
        name={endDateName}
        control={control}
        rules={{
          validate: () =>
            errorString ||
            startEndError ||
            dateRangeValidate(startDate as Date, endDate as Date, rangeDay),
        }}
        render={({ field }) => {
          return (
            <DatePicker
              {...other}
              {...field}
              {...getErrorHelperText(endDateError)}
              required={required}
              value={field.value}
              disabled={isDisabled}
              isDisabled={isDisabled}
              onChange={({ value }) => {
                trigger(startDateName);
                field.onChange(value);
              }}
            />
          );
        }}
      />
    </div>
  );
};
export default DateTimeStartEnd;
